import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { BASE_URL } from '../Config';

const Header = () => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [profileData, setProfileData] = useState(null);

    const headerStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '17px 30px',
        backgroundColor: '#f8f9fa',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    };

    const searchContainerStyle = {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    };
    const profileContainerStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        position: 'relative',
    };

    const profilePicStyle = {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        objectFit: 'cover',
        cursor: 'pointer',
    };

    const bellIconStyle = {
        fontSize: '1.5rem',
        cursor: 'pointer',
    };

    const profileDropdownStyle = {
        position: 'absolute',
        top: '50px',
        right: '0',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        width: '200px',
        padding: '10px',
        zIndex: 1000,
    };

    const profileNameStyle = {
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '5px',
    };

    const profileDetailsStyle = {
        fontSize: '12px',
        color: '#555',
    };

    const logoutButtonStyle = {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#dc3545',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        padding: '5px 10px',
        cursor: 'pointer',
        marginTop: '10px',
    };

    const handleProfileClick = async () => {
        setIsProfileOpen(!isProfileOpen);
        if (!profileData) {
            try {
                const id = localStorage.getItem("id");
                const response = await fetch(`${BASE_URL}/api/user/${id}`);
               
                const data = await response.json();
                localStorage.setItem("email", data.email);
                setProfileData(data);
            } catch (error) {
                console.error('Error fetching profile data:', error);
            }
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('isLoggedIn');
        window.location.href = '/login';
        toast.success(`Logout successful!`);
        setIsProfileOpen(false);
    };

    return (
        <div style={headerStyle}>
            <div style={searchContainerStyle}>
            </div>
            <div style={profileContainerStyle}>
                <img
                    src="https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg?w=740&t=st=1694269159~exp=1694269759~hmac=c8c65095b670091331a550b674305943e6a42c710a45b7356ecfe851d77b916b"
                    alt="Profile"
                    style={profilePicStyle}
                    onClick={handleProfileClick}
                />
                <div style={bellIconStyle}>
                    <FontAwesomeIcon icon={faBell} />
                </div>
                {isProfileOpen && profileData && (
                    <div style={profileDropdownStyle}>
                        <img
                            src='https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg?w=740&t=st=1694269159~exp=1694269759~hmac=c8c65095b670091331a550b674305943e6a42c710a45b7356ecfe851d77b916b'
                            alt="Profile"
                            style={{ ...profilePicStyle, width: '50px', height: '50px', marginBottom: '10px' }}
                        />
                        <div style={profileNameStyle}>{profileData.name}</div>
                        <div style={profileDetailsStyle}>{profileData.email}</div>
                        <div style={profileDetailsStyle}>
                            WABA_ID-{profileData?.facebookData?.waba_id || "Not Registered"}
                        </div>
                        <div style={profileDetailsStyle}>
                            PHONENUMBER_ID-{profileData?.facebookData?.phone_number_id || "Not Registered"}
                        </div>
                        <button style={logoutButtonStyle} onClick={handleLogout}>
                            <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '5px' }} />
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
